module.exports = __webpack_public_path__ + "static/media/chinmay_barve.80bfbe52.png";